import { useState } from 'react';
import { BusinessesService } from 'service/businesses.service';

export const useSaveToMyContacts = () => {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const postContact = async (id: string, zoominfoPersonId: string) => {
    try {
      setLoading(true);
      await BusinessesService.saveToMyContacts(id, { zoominfoPersonId });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    setModal(true);
  };

  const closeModal = () => {
    setModal(true);
  };

  return {
    modal,
    postContact,
    openModal,
    closeModal,
    loading,
  };
};
